import React, { useEffect } from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";

function DeviceVerificationError() {
    const { t: tLang } = useTranslation();

    const phoneNumber = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );

    useEffect(() => {
        window.addToDataLayer({ event: "DEVICE-VERIFICATION-DENY-PAGE" });
    },[]);

    return (
        <>
            <div className="dv-container">
                <div className="dv-row dv-margin-vertical-xl">
                    <div className="box col-xs-12 box-has-shadow box-lg dv-box">
                        <div className="dv-row dv-inner-row">
                            <div className="col-xs-12 col-sm-12 text-align-center dv-col-main">
                                <div className="dv-info-circle-icon">
                                    <RenderIcons iconName="info-circle" />
                                </div>
                                <div className="dv-err-msg">
                                    {tLang("registration.deviceVerification.errorMessage1")} <br />
                                    {tLang("registration.deviceVerification.errorMessage2")} {` ${phoneNumber} `} {tLang("registration.deviceVerification.errorMessage3")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeviceVerificationError;
